import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { changeMapContainerArea } from 'shared/map-search/actions/mapContainerArea';
import { selectIsClustersRedesign } from 'shared/map-search/selectors/clustersType';
import { TThunkDispatch } from 'shared/map-search/types/redux';

import { useMapContext } from '../context';

export const MapSizeUpdater: React.FC = () => {
  const { map } = useMapContext();
  const dispatch = useDispatch<TThunkDispatch>();
  const isClustersRedesign = useSelector(selectIsClustersRedesign);

  React.useEffect(() => {
    const handleMapSizeChange = () => {
      const mapSize = map.container.getSize();
      const mapContainerArea = mapSize[0] * mapSize[1];

      dispatch(changeMapContainerArea(mapContainerArea));
    };

    handleMapSizeChange();

    map.events.add('boundschange', handleMapSizeChange);

    return () => {
      map.events.remove('boundschange', handleMapSizeChange);
    };
  }, [map, isClustersRedesign, dispatch]);

  return null;
};
